module.exports = __webpack_public_path__ + "img/bg-personal.bd073636.webp";